import * as api from '../../api/api-recepciona-caso';
import { 
    GET_CONFIG_FORM41,
    GET_DATOS_GESTION,
    GET_COMBO_AMBITO_GESTION,
    GET_COMBO_INSTANCIA_GESTION,
    GET_COMBO_MODO_CONTACTO,
    GET_DATOS_CONTACTO,
    GET_COMBO_RESPUESTA_CONTACTO,
    OBTENER_LLAVES,
    POST_RECEPCION
} from '../types';


export const configuracionFormAction41 = (query) => ({
    type: GET_CONFIG_FORM41,
    payload: api.getConfiguracionForm41(query)
});
export const obtenerDatosGestion = (query) => ({
    type: GET_DATOS_GESTION,
    payload: api.getDatosGestion(query)
});
export const obtenerComboAmbitoGestion = (query) => ({
    type: GET_COMBO_AMBITO_GESTION,
    payload: api.getComboAmbitoGestion(query)
});
export const obtenerComboInstanciaGestion = (query) => ({
    type: GET_COMBO_INSTANCIA_GESTION,
    payload: api.getComboInstanciaGestion(query)
});
export const obtenerComboModoContacto = (query) => ({
    type: GET_COMBO_MODO_CONTACTO,
    payload: api.getComboModoContacto(query)
});
export const obtenerContactoTercero = (query) => ({
    type: GET_DATOS_CONTACTO,
    payload: api.getDatosContactoTercero(query)
});
export const obtenerComboRespuestaContacto = (query) => ({
    type: GET_COMBO_RESPUESTA_CONTACTO,
    payload: api.getComboRespuestaContacto(query)
});
export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const PostRecepciona = (newRecepcion) => ({
    type:POST_RECEPCION,
    payload: api.enviarRecepcion(newRecepcion)
});
